<script setup>
const { t } = useI18n();

useSeoMeta({
  title: () => t('seo.home.title'),
  description: () => t('seo.home.description'),
  ogTitle: () => t('seo.home.title'),
  ogDescription: () => t('seo.home.description'),
});
</script>

<template>
  <div>
    <Menu />
    <h1 class="sr-only">{{ $t('seo.home.title') }}</h1>
    <ProjectAccordeon slug="vithas" even priority />
    <ProjectAccordeon slug="edificio_plurifamiliar" odd />
    <ProjectAccordeon slug="oficines_simon" even />
    <ProjectAccordeon slug="residencia_vita_pedralbes" odd />
    <ProjectAccordeon slug="oller_del_mas" even />
    <Footer />
  </div>
</template>
